import React, { useState } from "react";

const NotesImg = ({ isActive }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fillColor = isActive ? "#EBF2F7" : isHovered ? "#1D4469" : "#969BA9";
  const bgColor = isActive ? "#1D4469" : "white";

  return (
    <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
        <rect
          x="0.5"
          y="0.5"
          width="32"
          height="32"
          rx="4.5"
          fill={bgColor}
          stroke={isHovered ? "#1D4469" : "#DFE2E5"}
        />

        <path
          d="M10 21.6772C10 23.2059 11.262 24.4498 12.8127 24.4498H18.1391C18.4596 24.4498 18.7189 24.1939 18.7189 23.8783C18.7189 23.7205 18.6539 23.5776 18.5489 23.4742C18.444 23.3709 18.2992 23.3069 18.1391 23.3069H12.8127C11.9012 23.3069 11.1595 22.5759 11.1595 21.6772V11.7726C11.1595 10.8739 11.9012 10.1429 12.8127 10.1429H20.6285C21.5406 10.1429 22.2823 10.8739 22.2823 11.7726V19.2229C22.2823 19.3808 22.3471 19.5236 22.452 19.627C22.5569 19.7304 22.7018 19.7944 22.862 19.7944C23.1825 19.7944 23.4418 19.5385 23.4418 19.2229V11.7726C23.4418 10.2439 22.1798 9 20.6285 9H12.8127C11.262 9 10 10.2439 10 11.7726V21.6772Z"
          fill={fillColor}
        />

        <path
          d="M20.0703 16.1535H15.6044C15.284 16.1535 15.0247 16.4093 15.0247 16.7249C15.0247 17.0405 15.284 17.2963 15.6044 17.2963H20.0703C20.3907 17.2963 20.65 17.0405 20.65 16.7249C20.65 16.4093 20.3907 16.1535 20.0703 16.1535Z"
          fill={fillColor}
        />
        <path
          d="M20.0703 13.4021H15.6044C15.284 13.4021 15.0247 13.6579 15.0247 13.9735C15.0247 14.2891 15.284 14.5449 15.6044 14.5449H20.0703C20.3907 14.5449 20.65 14.2891 20.65 13.9735C20.65 13.6579 20.3907 13.4021 20.0703 13.4021Z"
          fill={fillColor}
        />
        <path
          d="M20.0703 18.9049H15.6044C15.284 18.9049 15.0247 19.1607 15.0247 19.4763C15.0247 19.7919 15.284 20.0477 15.6044 20.0477H20.0703C20.3907 20.0477 20.65 19.7919 20.65 19.4763C20.65 19.1607 20.3907 18.9049 20.0703 18.9049Z"
          fill={fillColor}
        />

        <path
          d="M13.3828 13.4021H13.3771C13.0573 13.4021 12.8002 13.6579 12.8002 13.9735C12.8002 14.2891 13.0629 14.5449 13.3828 14.5449C13.7033 14.5449 13.9626 14.2891 13.9626 13.9735C13.9626 13.6579 13.7033 13.4021 13.3828 13.4021Z"
          fill={fillColor}
        />
        <path
          d="M13.3828 16.1535H13.3771C13.0573 16.1535 12.8002 16.4093 12.8002 16.7249C12.8002 17.0405 13.0629 17.2963 13.3828 17.2963C13.7033 17.2963 13.9626 17.0405 13.9626 16.7249C13.9626 16.4093 13.7033 16.1535 13.3828 16.1535Z"
          fill={fillColor}
        />
        <path
          d="M13.3828 18.9049H13.3771C13.0573 18.9049 12.8002 19.1607 12.8002 19.4763C12.8002 19.7919 13.0629 20.0477 13.3828 20.0477C13.7033 20.0477 13.9626 19.7919 13.9626 19.4763C13.9626 19.1607 13.7033 18.9049 13.3828 18.9049Z"
          fill={fillColor}
        />

        <path
          d="M21.3258 20.7371C21.228 20.8394 21.1658 20.9753 21.1658 21.127V22.2065H20.0703C19.9167 22.2065 19.7792 22.2677 19.6756 22.3637C19.5625 22.4694 19.4909 22.6138 19.4905 22.7779C19.4905 23.0935 19.7498 23.3493 20.0703 23.3493H21.1658V24.4286C21.1658 24.7441 21.4251 25 21.7456 25C22.066 25 22.3253 24.7441 22.3253 24.4286V23.3493H23.4203C23.7407 23.3493 24 23.0935 24 22.7779C24 22.4623 23.7407 22.2065 23.4203 22.2065H22.3253V21.127C22.3253 20.8114 22.066 20.5555 21.7456 20.5555C21.5792 20.5558 21.4329 20.6261 21.3258 20.7371Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default NotesImg;
